import { Button } from "common/components/ui/Button";
import { DialogDescription, DialogTitle } from "common/components/ui/Dialog";
import { DrawerDescription, DrawerTitle } from "common/components/ui/Drawer";
import useWorkspaceProxyMutations from "common/datahooks/useWorkspaceProxyMutations";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { CustomProxy } from "common/types";

interface DeleteProxyProps {
  proxy: CustomProxy;
  onBack: () => void;
  onSuccess: () => void;
}

export default function DeleteProxy({
  proxy: { id, name },
  onBack,
  onSuccess,
}: DeleteProxyProps) {
  const isDesktop = useTwBreakpoint("lg");

  const { deleteProxy, isDeletingProxy } = useWorkspaceProxyMutations();

  function onDelete() {
    deleteProxy({ proxyId: id }).then(() => onSuccess());
  }

  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  return (
    <>
      <Title>Delete proxy</Title>
      <Description className="mb-8">
        Are you sure you want to delete{" "}
        <span className="break-words font-semibold text-black-950">{name}</span>
        ?
      </Description>
      <div className="flex items-center justify-between gap-x-2.5">
        <Button
          variant="secondary-black"
          onClick={onBack}
          disabled={isDeletingProxy}
          className="lg:flex-1"
        >
          Cancel
        </Button>

        <Button
          variant="outline-danger"
          isLoading={isDeletingProxy}
          className="lg:flex-1"
          onClick={onDelete}
        >
          Delete
        </Button>
      </div>
    </>
  );
}
